module.exports = __webpack_public_path__ + "static/media/icon-1w.5bf58b7a.svg";